import * as React from 'react';

// API
import apibridge from '../../apibridge';

// UTILS
import { queryStringToObject, validationErrorsToString } from '../../utils';

// REDUX
import { useAppSelector } from '../../store';

// PACKAGES
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

// COMPONENTS
import CertificationStaff from './Staff/CertificationStaff';
import CertificationParent from './Parent/CertificationParent';
import CertificationVisitor from './Visitor/certificationVisitor';
import CertificationStudent from './Student/CertificationStudent';

// TYPES
import {
	DomainProfileType,
	OrganisationFindOrganisationSummary,
	OrganisationProfileCheckProfileCheckResult
} from '../../api/models';

interface AddCertificationTypes {}

export const AddCertification: React.FC<AddCertificationTypes> = ({}) => {
	const location = useLocation();

	const [showError, setShowError] = React.useState<boolean>(false);

	const [formErrorMessage, setFormErrorMessage] = React.useState<string>();

	const [isLoading, setIsLoading] = React.useState<boolean>(false);

	const lists = useAppSelector((state) => state.lists);

	const [profile, setProfile] = React.useState<{ label?: string; value?: DomainProfileType } | undefined>();

	const [organisation, setOrganisation] = React.useState<OrganisationFindOrganisationSummary | undefined>();

	const [profileCheck, setProfileCheck] = React.useState<OrganisationProfileCheckProfileCheckResult>();

	const [paramsSuccess, setParamsSuccess] = React.useState<boolean>(false);

	//Get Organisation ID and TYPE
	const checkLocationParams = async () => {
		setFormErrorMessage('');

		setShowError(false);

		const locationParams = location.state;

		const queryParams = queryStringToObject();

		// merge in location state and query string
		// short names in query string, id becomes organisationIdentifier, type becomes profileType
		const params = {
			organisationIdentifier: queryParams.id || undefined,

			profileType: queryParams.type || undefined,

			...locationParams
		};

		setIsLoading(true);

		if (params.organisationIdentifier && params.profileType) {
			const selectedProfile =
				lists?.profileTypes?.filter((item) => item.value?.toLowerCase() === params.profileType?.toLowerCase())[0] ||
				undefined;

			if (selectedProfile) {
				setProfile(selectedProfile);
			}

			const responses = await Promise.all([
				apibridge.getOrganisationByIdentifier(params.organisationIdentifier),
				apibridge.getOrganistationProfileCheck({
					organisationIdentifier: params.organisationIdentifier,
					profileType: params.profileType
				})
			]);
			const [organisationResponse, profileCheckResponse] = responses;

			if (organisationResponse.isError || profileCheckResponse.isError) {
				setShowError(true);

				const validationMessages = [
					...(organisationResponse.validationErrors || []),
					...(profileCheckResponse.validationErrors || [])
				];

				setFormErrorMessage(
					validationMessages.length ? validationErrorsToString(validationMessages) : 'An error has occurred'
				);
			} else {
				setShowError(false);

				setOrganisation(organisationResponse.result);

				setProfileCheck(profileCheckResponse.result);

				setParamsSuccess(true);
			}

			setIsLoading(false);
		}
	};

	React.useEffect(() => {
		if (lists) {
			checkLocationParams();
		}
	}, [lists]);

	if (showError) {
		return <div className="form-validation-error">{formErrorMessage}</div>;
	} else {
		return (
			<>
				{profile?.value === 'Staff' ? (
					<CertificationStaff organisationData={organisation} profileData={profile} profileCheck={profileCheck} />
				) : profile?.value === 'Parent' ? (
					<CertificationParent organisationData={organisation} profileData={profile} profileCheck={profileCheck} />
				) : profile?.value === 'Visitor' ? (
					<CertificationVisitor organisationData={organisation} profileData={profile} profileCheck={profileCheck} />
				) : profile?.value === 'Student' ? (
					<CertificationStudent organisationData={organisation} profileData={profile} profileCheck={profileCheck} />
				) : (
					<Link className="btn-primary submit-btn m-auto" to="/find-organisation">
						Join an Organisation
					</Link>
				)}
			</>
		);
	}
};

export default AddCertification;
